





























































import {Component, Vue, Watch} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import MallsTab from '@/components/common/MallsTab.vue';
import GroupItem from '@/components/member/group/GroupItem.vue';
import GroupInfo from '@/components/member/group/GroupInfo.vue';
import {Mall, GetMemberGroupsRequest, GetMemberGroupsGroupNoRequest, PutMemberGroupsGroupNoOrderRequest} from 'supporter';

const mallModule = namespace('mall');
@Component({
  components: {MallsTab, GroupItem, GroupInfo}
})
export default class MemberGroup extends Vue {
  // malls
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private memberAccumulationUseYn = true;
  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async mallNoChanged() {
    await this.changeMall();
  }
  private get showMallName() {
    let mallName = '';
    if (this.malls.length > 0) {
      this.malls.forEach((mall: Mall) => {
        if (mall.mallNo === this.mallNo) {
          mallName = mall.mallName;
        }
      });
    }
    return mallName;
  }

  // groups
  private groups = [];
  private showIdx = 0;

  private async groupUp() {
    if (this.showIdx > 0 && this.showIdx !== -1) {
      let moveItem = this.groups[this.showIdx];
      await this.moveGroup(moveItem.no, moveItem.order, 'up');
    }
  }
  private async groupDown() {
    if (this.showIdx !== this.groups.length - 1 && this.showIdx !== -1) {
      let moveItem = this.groups[this.showIdx];
      await this.moveGroup(moveItem.no, moveItem.order, 'down');
    }
  }
  private async moveGroup(groupNo: string, oldOrder: number, type: string) {
    let request: PutMemberGroupsGroupNoOrderRequest = {
      pathParams: {
        groupNo
      },
      data: {
        newOrder: type === 'up' ? oldOrder + 1 : oldOrder - 1,
        mallNo: this.mallNo,
        currentOrder: oldOrder
      }
    };
    await this.$api.putMemberGroupsGroupNoOrder(request);
    await this.getGroups();
    this.showIdx = type === 'up' ? this.showIdx - 1 : this.showIdx + 1;
    this.groups[this.showIdx].name = this.groupInfo.name;
  }
  private async addGroup() {
    if (this.showIdx === -1) {
      if (confirm(this.$t('MEMBER_GROUP_COMFIRM_MOVE') as string)) {
        if (this.checkInfo()) {
          await this.saveGroup();
          await this.getGroups();
        } else {
          return;
        }
      } else {
        this.groups = this.groups.filter((item, idx) => idx !== this.groups.length - 1);
      }
    }
    let groupItem = {
      memberCount: 0,
      name: this.$t('MEMBER_GROUP_DETAIL_NEW_GROUP_NAME') as string,
      no: -1,
      order: -1,
      showIdx: -1
    };
    let newGroupInfo = {
      name: this.$t('MEMBER_GROUP_DETAIL_NEW_GROUP_NAME') as string,
      no: -1,
      description: '',
      reserveBenefit: {
        reserveRate: '',
        used: false
      }
    };
    this.showIdx = -1;
    this.groups.push(groupItem);
    this.groupInfo = newGroupInfo;
  }
  private async delGroup() {
    if (this.groups.length > 0) {
      if (this.groups[this.showIdx].memberCount > 0) {
        alert(this.$t('MEMBER_GROUP_ERR_HAVE_MEMBER'));
        return;
      }
      if (confirm(this.$t('MEMBER_GROUP_COMFIRM_DELETE_GROUP') as string)) {
        if (this.showIdx === -1) {
          this.groups = this.groups.filter((item, idx) => idx !== this.groups.length - 1);
        } else {
          let request = {
            pathParams: {
              groupNo: this.groups[this.showIdx].no
            }
          };
          await this.$api.deleteMemberGroupsGroupNo(request);
          await this.getGroups();
        }
        this.showIdx = 0;
        await this.getGroupInfo();
      }
    }
  }
  private async editShowIdx(idx: number) {
    if (this.checkEdit() && confirm(this.$t('MEMBER_GROUP_COMFIRM_MOVE') as string)) {
      if (this.checkInfo()) {
        await this.saveGroup();
        if (this.showIdx === -1) {
          await this.getGroups();
          this.showIdx = idx + 1;
        }
        this.showIdx = idx;
        await this.getGroupInfo();
      }
    } else {
      if (this.showIdx === -1) {
        this.groups = this.groups.filter((item, idx) => idx !== this.groups.length - 1);
      } else {
        this.groups[this.showIdx].name = this.oldGroupInfo.name;
      }
      this.showIdx = idx;
      await this.getGroupInfo();
    }
  }
  private checkEdit() {
    // 회원그룹추가
    if (this.showIdx === -1) {
      return true;
    }
    // 그룹 이름
    if (this.groupInfo.name !== this.oldGroupInfo.name) {
      return true;
    }
    // 그룹 설명
    if (this.groupInfo.description !== this.oldGroupInfo.description) {
      return true;
    }
    // 그룹 적립금 혜택
    if (this.groupInfo.reserveBenefit.used !== this.oldGroupInfo.reserveBenefit.used) {
      return true;
    }
    if (this.groupInfo.reserveBenefit.reserveRate !== this.oldGroupInfo.reserveBenefit.reserveRate) {
      return true;
    }
    return false;
  }

  private async getGroups() {
    let request: GetMemberGroupsRequest = {
      params: {
        mallNo: this.mallNo,
        countMember: true
      }
    };
    let memberGroups = await this.$api.getMemberGroups(request);
    let tempGroups = await memberGroups.data.sort((itemA, itemB) => (itemA.order > itemB.order ? -1 : 1));
    this.groups = await tempGroups.map((group, idx) => {
      return {
        memberCount: group.memberCount,
        name: group.name,
        no: group.no,
        order: group.order,
        showIdx: idx
      };
    });
  }

  private async getGroupInfo() {
    if (this.groups.length > 0) {
      let request: GetMemberGroupsGroupNoRequest = {
        pathParams: {
          groupNo: this.groups[this.showIdx].no
        }
      };
      let {data} = await this.$api.getMemberGroupsGroupNo(request);
      this.oldGroupInfo = JSON.parse(JSON.stringify(data));
      this.groupInfo = JSON.parse(JSON.stringify(data));
    } else {
      this.oldGroupInfo = null;
      this.groupInfo = null;
    }
  }
  private oldGroupInfo = null;
  private groupInfo = null;

  private onDetailNameChange(nameInfo: any) {
    if (nameInfo.type === 'list') {
      this.groupInfo.name = nameInfo.name;
    } else {
      if (this.showIdx === -1) {
        this.groups[this.groups.length - 1].name = nameInfo.name;
      } else {
        this.groups[this.showIdx].name = nameInfo.name;
      }
    }
  }

  private async clickSave() {
    if (this.checkInfo()) {
      if (!confirm(this.$t('MEMBER_GROUP_COMFIRM_BEFORE_MODIFY') as string)) {
        return;
      }
      await this.saveGroup();
      window.location.reload();
    }
  }

  private async saveGroup() {
    let request: any = {
      data: {
        mallNo: this.mallNo,
        name: this.groupInfo.name,
        description: this.groupInfo.description,
        reserveBenefit: {
          reserveRate: Number(this.groupInfo.reserveBenefit.reserveRate),
          used: this.groupInfo.reserveBenefit.used
        }
      }
    };
    if (this.groupInfo.no === -1) {
      await this.$api.postMemberGroups(request);
      await this.getGroups();
      let tempGroup = this.groups[0];
      let orderRequest: PutMemberGroupsGroupNoOrderRequest = {
        pathParams: {
          groupNo: tempGroup.no
        },
        data: {
          newOrder: 0,
          mallNo: this.mallNo,
          currentOrder: tempGroup.order
        }
      };
      await this.$api.putMemberGroupsGroupNoOrder(orderRequest);
    } else {
      request.pathParams = {
        groupNo: this.groupInfo.no
      };
      await this.$api.putMemberGroupsGroupNo(request);
    }
    alert(this.$t('MEMBER_GROUP_ALERT_SAVE'));
  }

  private checkInfo() {
    let groupDetail = this.$refs.groupDetail as any;
    // 그룹 이름
    if (this.groupInfo.name === '') {
      alert(this.$t('MEMBER_GROUP_ERR_GROUP_NAME_NULL'));
      groupDetail.focus('groupName');
      return false;
    }
    // 그룹 적립금 혜택
    if (this.groupInfo.reserveBenefit.used) {
      if (this.groupInfo.reserveBenefit.reserveRate === '') {
        alert(this.$t('MEMBER_GROUP_ERR_RESERVE_RATE_NULL'));
        groupDetail.focus('reserveRate');
        return false;
      }
      if (Number(this.groupInfo.reserveBenefit.reserveRate) <= 0) {
        alert(this.$t('MEMBER_GROUP_ERR_RESERVE_RATE_ZERO'));
        groupDetail.focus('reserveRate');
        return false;
      }
    }

    return true;
  }

  private async changeMall() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    let request = {
      pathParams: {
        mallNo: this.mallNo.toString()
      },
      params: {
        key: 'MALL_ACCUMULATION'
      }
    };
    let mallsConf = await this.$api.getMallsConfigurations(request);
    if (mallsConf && mallsConf.data) {
      this.memberAccumulationUseYn = mallsConf.data.memberAccumulationUseYn === true;
    } else {
      this.memberAccumulationUseYn = true;
    }

    await this.getGroups();
    this.showIdx = 0;
    await this.getGroupInfo();
  }

  private async mounted() {
    await this.changeMall();
  }
}
